import {context} from 'vue3-starter/src/typescript/app-context/AppContext';
import {HttpServiceResponse} from 'vue3-starter/src/typescript/http/http';
import {FunctionalScopeResource} from '@/common/api/api-raw-types';

export default class FunctionalSkillsRepository {
    async loadScopes(): Promise<HttpServiceResponse<FunctionalScopeResource[]>> {
        return context.httpService.get(context.registry.entries.allFunctionalScopes());
    }
}
